import { useEffect, useState } from 'react'

const MOBILE_QUERY = '(max-width: 1023px)'

export default function StartupSplash() {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined') return true
    return window.matchMedia(MOBILE_QUERY).matches
  })
  const [visible, setVisible] = useState(true)
  const [isExiting, setIsExiting] = useState(false)
  const [activeDot, setActiveDot] = useState(0)

  useEffect(() => {
    if (typeof window === 'undefined') return undefined

    const mediaQuery = window.matchMedia(MOBILE_QUERY)
    const updateIsMobile = () => setIsMobile(mediaQuery.matches)
    updateIsMobile()

    mediaQuery.addEventListener('change', updateIsMobile)
    return () => mediaQuery.removeEventListener('change', updateIsMobile)
  }, [])

  useEffect(() => {
    if (!isMobile) return undefined

    const dotsInterval = window.setInterval(() => {
      setActiveDot((prev) => (prev + 1) % 3)
    }, 650)

    const startExitTimer = window.setTimeout(() => {
      setIsExiting(true)
    }, 2700)

    const hideTimer = window.setTimeout(() => {
      setVisible(false)
    }, 3350)

    return () => {
      window.clearInterval(dotsInterval)
      window.clearTimeout(startExitTimer)
      window.clearTimeout(hideTimer)
    }
  }, [isMobile])

  if (!isMobile || !visible) return null

  return (
    <div className={`app-splash ${isExiting ? 'out' : ''}`} aria-hidden="true">
      <div className="app-splash-icon">
        <svg width="54" height="54" viewBox="0 0 54 54" fill="none">
          <ellipse cx="14" cy="18" rx="5.5" ry="7" fill="white" opacity=".85" transform="rotate(-15 14 18)" />
          <ellipse cx="22" cy="11" rx="5.5" ry="7" fill="white" opacity=".85" transform="rotate(-5 22 11)" />
          <ellipse cx="32" cy="11" rx="5.5" ry="7" fill="white" opacity=".85" transform="rotate(5 32 11)" />
          <ellipse cx="40" cy="18" rx="5.5" ry="7" fill="white" opacity=".85" transform="rotate(15 40 18)" />
          <ellipse cx="27" cy="36" rx="13" ry="11" fill="white" opacity=".95" />
          <path
            d="M27 30 C27 30 23 27 23 25 C23 23.3 24.3 22 26 22 C26.6 22 27 22.4 27 22.4 C27 22.4 27.4 22 28 22 C29.7 22 31 23.3 31 25 C31 27 27 30 27 30Z"
            fill="#7a9a52"
          />
        </svg>
      </div>
      <div className="app-splash-name">artemis.</div>
      <div className="app-splash-tag">Tu plataforma veterinaria</div>
      <div className="app-splash-bar">
        <div className="app-splash-fill" />
      </div>
      <div className="app-splash-dots">
        {[0, 1, 2].map((dot) => (
          <span key={dot} className={`app-splash-dot ${activeDot === dot ? 'on' : ''}`} />
        ))}
      </div>
    </div>
  )
}

